import type { ReactNode } from 'react';
import { useDocumentTitle } from '../hooks';

export interface HubPageProps {
  readonly title: string;
  readonly lead?: string;
  readonly children?: ReactNode;
}

/**
 * Frame of a section page (`/thi-thu`, `/sa-hinh`, `/toi`): the page heading, a one-line lead and
 * the content. Rendered inside the shell's `<main>`, so it is a plain block.
 */
export function HubPage({ title, lead, children }: HubPageProps) {
  useDocumentTitle(title);
  return (
    <div className="app-page">
      <h1>{title}</h1>
      {lead === undefined ? null : <p className="app-page__lead">{lead}</p>}
      {children}
    </div>
  );
}
